import moment from 'moment-jalaali';
import * as z from 'zod';

export const profileSchema = z.object({
  birthDate: z
    .string()
    .min(1, 'تاریخ تولد را وارد کنید.')
    .refine(
      (date) => {
        if (!date) return false;
        const age = moment(moment().format('jYYYY/jMM/jDD')).diff(date, 'years');
        return age >= 18 && age <= 100;
      },
      {
        message: 'سن باید بین 18 تا 100 سال باشد.',
      }
    ),
});
